module.exports = __webpack_public_path__ + "img/belfast_region_city_region_logo.8ef251ee.png";